<template>
    <div class="row">
        <input-date-time class="col-12 col-md-6" label="Data de emissão" v-model="form.data" ref="data_desembolso" required/>
        <input-money class="col-12 col-md-6" label="Valor" v-model="form.valor" ref="valor_desembolso" required/>
        <input-select-filter class="col-12" label="Empresa" :options="empresas" v-model="form.empresaId" ref="empresa" required/>
        <div class="col-12 mb-2">
            <upload v-if="!form.nomeArquivoAWS"
                id="upload_desembolso"
                tituloArquivo="Arrastar Arquivo" 
                selecioneArquivo="Selecionar Arquivo" 
                type=".*"

                :arquivo-download="form.conteudoBase64"
                :arquivo-download-nome="form.nomeArquivoAWSUP"
                
                @upload="(file, nomeArquivo)=> {                   
                    form.nomeArquivoAWSUP = nomeArquivo;
                    form.conteudoBase64 = file;
                    this.$forceUpdate();
                }" 
            />

            <template v-if="form.nomeArquivoAWS">
                <div>
                    Arquivo
                    <div class="lista-arquivos d-flex">
                        <b-button variant="danger" @click="() =>{this.form.nomeArquivoAWS = null;}" class="m-2" size="sm">
                            <b-icon icon="trash" class="mr-2" />
                            Remover arquivo
                        </b-button>
                        <b-button variant="info" @click="() => {this.$emit('downloadArquivo', this.form.id);}" class="m-2" size="sm">
                            <i class="fas fa-cloud-download"></i>
                        </b-button>
                        <div  style="border-left: 1px solid #e5e5e5;" class="lista-arquivos__left d-flex pl-2 align-items-center">
                            {{form.nomeArquivoAWS}}
                        </div>
                    </div>
                </div>
            </template>
        </div>
    </div>
</template>
<script>
import {FormMixin} from "@/common/mixins/FormMixin";
import InputDateTime from "@/components/inputs/InputDateTime";
import InputMoney from "@/components/inputs/InputMoney";
import Upload from "@/components/upload/Upload";

import helpers from "@/common/utils/helpers"
import InputSelectFilter from "@/components/inputs/InputSelectFilter.vue";
import EmpresasService from "@/common/services/empresas/empresas.service";
export default {
    mixins: [FormMixin],
    components : {
        InputDateTime,
        InputMoney,
        Upload,
        InputSelectFilter
    },
    props : {
        form : {
            required : true,
        }
    },
    data : () => ({
        options : {
            uf : helpers.UF
        },
        empresas : [],
    }),
    mounted(){
        this.buscarEmpresas();
    },
    methods : {
        buscarEmpresas : function(){
            EmpresasService.buscarTipo('Executora').then(res => {
                this.empresas = res.data.data.map(el => {return {value: el.id, text: el.nomeFantasia || el.razaoSocial, logo: el.logoDaEmpresa, data: el}});
            });
        }
    }
}
</script>
<style>
    .lista-arquivos{
        border: 1px solid #e5e5e5;
        background: #f9f9f9;
    }
    .lista-arquivos__no_top{
        border-top: none;
    }
    .lista-arquivos__left{
        border-left: 1px solid #e5e5e5;
    }
</style>